module.exports = __webpack_public_path__ + "img/lemon.d7bb7380.svg";